module.exports = __webpack_public_path__ + "media/Video_switch_to_registration.322b2471.mp4";